export default () => {
  const x = window.matchMedia('(hover)');

  return x.matches;
};

// const x = window.matchMedia('((max-width: 700px))');
// myFunction(x) // Call listener function at run time
